module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/19725087656ad7fa8228060ca86306a7.png";